/**
 * 費用表示。API の課金は USD なので、社内で見やすいよう円換算して出す。
 * レートは概算用。正確な請求額は OpenAI のダッシュボードを参照のこと。
 */
export const USD_TO_JPY = 150;

/** 円に換算した数値 */
export function toJpy(usd: number): number {
  return Number(usd || 0) * USD_TO_JPY;
}

/**
 * 「¥1,234」形式。小さい額は小数を出さないと 0 に潰れるので、
 * 10円未満だけ小数1桁まで見せる。
 */
export function formatJpy(usd: number): string {
  const yen = toJpy(usd);
  if (yen === 0) return "¥0";
  if (yen < 10) return `¥${yen.toFixed(1)}`;
  return `¥${Math.round(yen).toLocaleString("ja-JP")}`;
}

/** ツールチップ用に「¥1,234（$8.23）」と両方出す */
export function formatJpyWithUsd(usd: number): string {
  return `${formatJpy(usd)}（$${Number(usd || 0).toFixed(3)}）`;
}
